import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, Card } from "../components/primitives";

export default function AdverseMedia() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/screening/lists").then(r => setD(r.data)); }, []);
  if (!d) return <div className="p-6 text-[13px] text-ink-muted">Loading…</div>;
  return (
    <div>
      <PageHeader title="Adverse Media" subtitle={`${d.media.length} entries · Premium Times, Sahara Reporters, Punch, BBC Africa, Reuters Africa…`} sections={["5.3"]} />
      <div className="p-6 grid grid-cols-2 gap-3">
        {d.media.map(m => (
          <Card key={m.id}>
            <div className="p-4">
              <div className="flex items-baseline justify-between">
                <span className="text-[13px] font-medium">{m.subject}</span>
                <span className="text-[10px] px-1.5 py-0.5 bg-bg-subtle rounded">{m.category}</span>
              </div>
              <div className="text-[12px] mt-2 italic">"{m.headline}"</div>
              <div className="text-[11px] text-ink-subtle mt-2">{m.source} · {m.date}</div>
              <div className="text-[11px] text-ink-muted mt-2">{m.summary}</div>
              <div className="flex gap-1 mt-2">
                <button className="px-2 py-0.5 text-[11px] border border-line rounded-sm">Link to customer</button>
                <button className="px-2 py-0.5 text-[11px] border border-line rounded-sm">Mark reviewed</button>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
